import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { NonprofitCategory, NonprofitDetails } from '../../models'
import { ApiError } from '../../services/api/api-error-data'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useAppDialog } from '../../hooks/use-app-dialog'
import { AppDialogVariants } from '../../store/app-dialog/types'
import { trackException } from '../../store/app-insights/reducer'
import { nonprofitsApi } from '../../services/api/nonprofits'

type UseNonprofitDetailsPage = {
  detailProps?: NonprofitDetails
  nonprofitCategory?: NonprofitCategory
  loading: boolean
  getNonprofitDetails: (actions: React.ReactNode) => void
  loadSelectCategory: (value: number) => void
}

export const useNonprofitDetailsPage = (): UseNonprofitDetailsPage => {
  const navigate = useNavigate()
  const { externalId } = useParams()
  const dispatch = useDispatch()
  const [detailProps, setDetailProps] = useState<NonprofitDetails>()
  const { t } = useTranslation()
  const [loading, setLoading] = useState<boolean>(true)
  const [nonprofitCategory, setNonprofitCategory] =
    useState<NonprofitCategory>()
  const { setAppDialog } = useAppDialog()

  //Get Listed Item Details
  const getNonprofitDetails = (actions: React.ReactNode) => {
    nonprofitsApi
      .getInfoByExternalId(externalId ? externalId : '0')
      .then((data) => {
        setLoading(false)
        setDetailProps(data)
      })
      .catch((reason) => {
        setAppDialog({
          isShow: true,
          title: 'Error',
          message: (reason as ApiError).getErrorMessage(t),
          variant: AppDialogVariants.error,
          actions,
          closeHandler: () => navigate(-1),
        })
        setLoading(false)
        dispatch(trackException({ e: reason, source: 'getNonprofitDetails' }))
      })
  }

  /**Get Categories*/
  const loadSelectCategory = async (nonprofitCategoryId: number) => {
    await nonprofitsApi
      .categories()
      .then((data) => {
        const category = data.filter(
          (item: NonprofitCategory) =>
            item.nonprofitCategoryId === nonprofitCategoryId
        )[0]
        setNonprofitCategory(category)
      })
      .catch((e) =>
        dispatch(trackException({ e, source: 'loadSelectCategory' }))
      )
  }

  return {
    detailProps,
    nonprofitCategory,
    loading,
    getNonprofitDetails,
    loadSelectCategory,
  }
}
